import { render, staticRenderFns } from "./FullPageGradient.vue?vue&type=template&id=8c9b4d3a&scoped=true"
import script from "./FullPageGradient.vue?vue&type=script&lang=js"
export * from "./FullPageGradient.vue?vue&type=script&lang=js"
import style0 from "./FullPageGradient.vue?vue&type=style&index=0&id=8c9b4d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b4d3a",
  null
  
)

export default component.exports